import DeadlineDateFilter from 'components/brokers/workflows/DeadlineDateFilter'

import { type SingleSelectedValueFilter } from '../types'

const CoverageStartDateAfterFilter = (props: SingleSelectedValueFilter) => {
  return (
    <DeadlineDateFilter {...props} rangeType='Coverage start after' />
  )
}

export default CoverageStartDateAfterFilter
